const calcHeight = element => {
  const height = [].reduce.call(element.childNodes, (p, c) => (p + (c.clientHeight || 0)), 0);
  return height + height/1.9 + 'px';
};

export default el => {
  const titleElement = el.querySelector('.accordeon__title');
  const contentElement = el.querySelector('.accordeon__content');

  setTimeout(() => {
    if (el.classList.contains('accordeon--active')) {
      contentElement.style.maxHeight = calcHeight(contentElement);
    }
  }, 0);

  titleElement.addEventListener('click', () => {
    el.classList.toggle('accordeon--active');
    if (el.classList.contains('accordeon--active')) {
      contentElement.style.maxHeight = calcHeight(contentElement);
    } else {
      contentElement.style.maxHeight = '0';
    }
  });
}
